'use strict';

module.exports = function (Chart) {
  Chart.Doughnut = function (context, config) {
    config.type = 'doughnut';
    return new Chart(context, config);
  };
};